import { RouterModule, Routes } from '@angular/router';
import { ViewConsignmentComponent } from './components/view-consignment/view-consignment.component';
import { HomeConsignmentComponent } from './components/home-consignment/home-consignment.component';
import { ListConsignmentComponent } from './components/list-consignment/list-consignment.component';
import { ListConsignmentStatesComponent } from './components/list-consignment-states/list-consignment-states.component';
import { ListConsignmentPaymentsComponent } from './components/list-consignment-payments/list-consignment-payments.component';
import { ListConsignmentReturnsComponent } from './components/list-consignment-returns/list-consignment-returns.component';


export const ConsignmentserviceRouter: Routes = [
    { path: '', component: HomeConsignmentComponent },
    { path: 'create', component: ViewConsignmentComponent },
    { path: 'view/:id', component: ViewConsignmentComponent },
    { path: 'list', component: ListConsignmentComponent },
    { path: 'list-states', component: ListConsignmentStatesComponent },
    { path: 'list-payments', component: ListConsignmentPaymentsComponent },
    { path: 'list-returns', component: ListConsignmentReturnsComponent },
];


// WEBPACK FOOTER //
// ./src/app/consignment/consignment.router.ts